"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const foundations_icons_Icon = require("../../../foundations/icons/Icon.js");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const components_input_foundations_Checkbox_Checkbox = require("../../input/foundations/Checkbox/Checkbox.js");
const components_input_foundations_Checkbox_hooks_useCheckboxContext = require("../../input/foundations/Checkbox/hooks/useCheckboxContext.js");
const Badge_module = require("../../../chunks/Badge.module-qXTkEAZZ.js");
const BadgeCheckbox = React.forwardRef(
  ({ children, value, className, ...props }, ref) => {
    const { state } = components_input_foundations_Checkbox_hooks_useCheckboxContext.useCheckboxGroupProvider();
    const isSelected = state.isSelected(value);
    return /* @__PURE__ */ jsxRuntime.jsx(
      components_input_foundations_Checkbox_Checkbox.Checkbox,
      {
        ref,
        value,
        className: clsx.clsx(Badge_module.styles.badge, Badge_module.styles.badgeCheckbox, className),
        selectedClassName: clsx.clsx(Badge_module.styles.badgeIsSelected, Badge_module.styles.badgeIsDismissible),
        pressedClassName: Badge_module.styles.badgeIsPressed,
        focusedClassName: Badge_module.styles.badgeIsFocused,
        ...props,
        children: /* @__PURE__ */ jsxRuntime.jsxs(foundations_typography_Text_Text.Text, { variant: "text-body-head", component: "span", className: Badge_module.styles.badgeText, children: [
          children,
          isSelected ? /* @__PURE__ */ jsxRuntime.jsx(foundations_icons_Icon.Icon, { variant: "XSmall", "aria-hidden": true }) : null
        ] })
      }
    );
  }
);
exports.BadgeCheckbox = BadgeCheckbox;
